<template>
  <TableLayout :permissions="['business:activity:query']">
    <!-- 搜索表单 -->
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
      <el-form-item label="资讯标题" prop="name">
        <el-input v-model="searchForm.name" placeholder="请输入资讯标题" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="活动状态" prop="activityStatus">
        <el-select
          v-model="searchForm.activityStatus"
          placeholder="请选择活动状态"
        >
          <el-option
            v-for="item in activityStatus"
            :key="item.id"
            :value="item.id"
            :label="item.label"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="活动时间">
        <el-date-picker
          v-model="activityTime"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm:ss"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="selectActivityTime"
        ></el-date-picker>
      </el-form-item>
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <ul class="toolbar" v-permissions="['business:activity:create', 'business:activity:delete']">
        <li><el-button type="primary" @click="$refs.operaActivityWindow.open('新建')" icon="el-icon-plus" v-permissions="['business:activity:create']">新建</el-button></li>
        <li><el-button type="danger" @click="deleteByIdInBatch" icon="el-icon-delete" v-permissions="['business:activity:delete']">删除</el-button></li>
      </ul>
      <el-table
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
        border
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" ></el-table-column>
        <el-table-column prop="name" label="活动标题" align="center" min-width="100px">
          <template slot-scope="{row}">
            <el-button type="text" @click="shopDetail(row)">{{ row.name }}</el-button>
          </template>
        </el-table-column>
        <el-table-column label="主办方" align="center" min-width="100px">
          <template slot-scope="{row}">
            {{ row.shopName || row.orgName }}
          </template>
        </el-table-column>
        <el-table-column label="主办方类型" align="center" min-width="90px">
          <template slot-scope="{row}">
            {{ (row.shopName && '商家') || (row.orgName && '机构')  }}
          </template>
        </el-table-column>
        <el-table-column label="报名人数" align="center" min-width="100px">
          <template slot-scope="{row}">
            {{ `${row.activityCount}/${row.limitnum}` }}
          </template>
        </el-table-column>

        <el-table-column prop="addr" label="活动地址" align="center" min-width="180px"></el-table-column>
        <el-table-column prop="price" label="活动价格(元)" align="center" min-width="100px"></el-table-column>
        <el-table-column prop="signStarttime" label="活动报名开始时间" align="center" min-width="140px"></el-table-column>
        <el-table-column prop="signEndtime" label="活动报名结束时间" align="center" min-width="140px"></el-table-column>
        <el-table-column prop="starttime" label="活动开始时间" align="center" min-width="140px"></el-table-column>
        <el-table-column prop="endtime" label="活动结束时间" align="center" min-width="140px"></el-table-column>
        <el-table-column label="活动状态" align="center" min-width="140px">
          <template slot-scope="{row}">
            {{ `${row.activityCount}/${row.limitnum}` }}
          </template>
        </el-table-column>
        <el-table-column
          v-if="containPermissions(['business:activity:update', 'business:activity:delete'])"
          label="操作"
          min-width="120"
          fixed="right"
        >
          <template slot-scope="{row}">
            <el-button type="text" @click="$refs.operaActivityWindow.open('编辑', row)" icon="el-icon-edit" v-permissions="['business:activity:update']">编辑</el-button>
            <el-button type="text" style="color: red;" @click="deleteById(row)" icon="el-icon-delete" v-permissions="['business:activity:delete']">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
    <!-- 新建/修改 -->
    <OperaActivityWindow ref="operaActivityWindow" @success="handlePageChange"/>
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaActivityWindow from '@/components/business/OperaActivityWindow'
export default {
  name: 'Activity',
  extends: BaseTable,
  components: { TableLayout, Pagination, OperaActivityWindow },
  data () {
    return {
      activityTime: [],
      // 搜索
      searchForm: {
        name: '',
        realName: '',
        activityStatus: '',
        starttime: '',
        endtime: '',
        type: 1 //类型0商家活动 1平台活动 2探店 3资讯
      },

      activityStatus: [
        // 0未开始 1报名中,2报名结束,3活动进行中,4活动已结束
        { label: '未开始', id: 0 },
        { label: '报名中', id: 1 },
        { label: '报名结束', id: 2 },
        { label: '活动进行中', id: 3 },
        { label: '活动已结束', id: 4 },
      ]
    }
  },
  created () {
    this.config({
      module: '资讯信息表',
      api: '/business/activity',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  },
  methods: {
    selectActivityTime(v) {
      if (!v) {
        this.searchForm.starttime = ''
        this.searchForm.endtime = ''
      } else {
        this.searchForm.starttime = v[0]
        this.searchForm.endtime = v[1]
      }
    },
    userTypeToStr(type) {
      const temp = this.userType.find(item => item.id = type)
      return temp ? temp.label : '-'
    },
    reset() {
      this.activityTime = []
      this.$refs.searchForm.resetFields()
      this.search()
    },
    shopDetail(row) {

    }
  },
}
</script>
